import { defineComponent as _defineComponent } from 'vue'
import { EntityTypeProperty } from '@/entities/entityTypeProperty';
  import { ValidationError } from '@/entities/validation';
  import { InputField } from '@/ui/components/form';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TextPropertyInput',
  props: {
    property: {
      type: Object as () => EntityTypeProperty,
      required: true,
    },
    modelValue: {
      type: [String, null],
      default: null,
    },
    errors: {
      type: Array as () => ValidationError[],
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  setup(__props, { emit }) {

  

  

  const handleInput = (value: string) => {
    emit('input', value);
  };

return { __sfc: true,emit, handleInput, InputField }
}

})